import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { getTestLabels } from '../../utils/getTestLabels.js';
import style from './Switch.module.scss.js';

const { componentTestLabel, elementTestLabel } = getTestLabels('Switch');
/**
 * [design (Figma)](https://www.figma.com/design/MUnGlxUUspXSbRkFsEXWGQ/%F0%9F%92%A0-Core-Components?node-id=1-14&t=YAlbF4HtOf8OzMLA-0)
 * | [source code](https://src.private.zooplus.net/projects/FE/repos/ui-components/browse/src/components/Form/Switch/Switch.tsx)
 *
 * The Switch component should be used when a setting will be applied immediately (without any further explicit user action such as a form submit).
 * It should be controlled from outside, meaning the `isPressed` prop should be managed by a parent component.
 *
 * @param {boolean} isPressed - (optional) Set to `true` when toggled "on"
 */
const Switch = forwardRef((props, ref) => {
    const { children, isPressed, className, ...otherProps } = props;
    return (jsxs("button", { "data-zta": componentTestLabel, ref: ref, ...otherProps, className: classNames(style['z-switch'], className), type: "button", "aria-pressed": isPressed, children: [jsx("span", { "data-zta": elementTestLabel('Track'), className: style['z-switch__track'] }), children] }));
});
Switch.displayName = 'Switch';

export { Switch };
//# sourceMappingURL=Switch.js.map
